import { Title } from "../shared/title/title.tsx";
import './media.css'
import shots from './shots.json';
import SimpleImageSlider from "react-simple-image-slider";


function Media() {

    const images: { url: string }[] = shots.imgs.map((img: string) => {
        return {
            url: img
        }
    })

    const isMobile: boolean = window.screen.width < 1024;

    const slideshowSize: {width: number, height: number} = {
        width: isMobile? 350 : 1000,
        height: isMobile? 210 : 600
    }

    return (
        <div id='media' className="animated">
            <Title value='Media' />
            <div id='media-container'>
                <SimpleImageSlider
                    style={{
                        border: isMobile ? 'solid 1px white' : 'solid 3px white'
                    }}
                    images={images}
                    width={slideshowSize.width}
                    height={slideshowSize.height}
                    showNavs
                    showBullets={!isMobile}
                    autoPlay
                    autoPlayDelay={5.0}
                    loop />
            </div>

        </div>
    );
}

/*function MediaWrapper(props: {img: string}){
    const divStyle = {
        border: "solid 3px white"
    }
    
    const imgStyle = {
        background: `url(${props.img})`,
        backgroundSize: 'cover',
        //width: '400px',
        
        height: '30vh'
    }


    return (
        <div style={divStyle}>
            <div style={imgStyle}>
            </div>
        </div>
    )
}
*/

export { Media }